import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import PublicPatientScheduling from '../../components/booking/PublicPatientScheduling';
import { 
  setDate, 
  setTime, 
  setSessionTypeId, 
  setProviderAvailabilityId,
  setProviderId,
  setServiceType,
  setLocationType,
  setLocationId,
  setTimeCreated,
  setScheduleManually,
  // setError,
  reset,
} from '../../redux/reducers/newAppointmentForm';

const MatchProviderForm = props => {
  const [stepIndex, setStepIndex] = useState(0);
  const childProps = {
    ...props,
    // stepTitle: 'Find the perfect provider',
    step: stepIndex + 1,
    // numSteps: 6,
    stepIndex: stepIndex,
    hideFirstStep: true,
    setStepIndex: setStepIndex,
    afterSubmit: ({providerId}) => props.afterSubmit({providerId}),
  };
  return <PublicPatientScheduling {...childProps} />;
};

const mapState = state => {
  // console.log('PublicBookingPage.state.newAppointmentForm', state.newAppointmentForm);
  return {};
};

const mapDispatch = dispatch => ({
  saveDate: dateStr => dispatch(setDate(dateStr)),
  saveTime: timeStr => dispatch(setTime(timeStr)),
  saveSessionTypeId: sessionTypeId => dispatch(setSessionTypeId(sessionTypeId)),
  saveProviderAvailabilityId: providerAvailabilityId => 
    dispatch(setProviderAvailabilityId(providerAvailabilityId)),
  saveProviderId: providerId => dispatch(setProviderId(providerId)),
  saveServiceType: serviceType => dispatch(setServiceType(serviceType)),
  saveLocationType: locationType => dispatch(setLocationType(locationType)),
  saveLocationId: locationId => dispatch(setLocationId(locationId)),
  saveTimeCreated: timeCreated => dispatch(setTimeCreated(timeCreated)),
  saveScheduleManually: scheduleManually => dispatch(setScheduleManually(scheduleManually)),
  reset: () => dispatch(reset()),
});

const MatchProviderFormContainer = connect(mapState, mapDispatch)(MatchProviderForm);

MatchProviderForm.propTypes = {
  afterSubmit: PropTypes.func,
};

export default MatchProviderFormContainer;